<script setup lang="ts">
import AdvertisingImg from './images/news1.jpg';
const NEWS_INFO = [
  {
    title: 'CRE (Commercial Real Estate) ',
    subtitle:
      ' Журнал №1 о коммерческой недвижимости России, ' +
      'выходит 2 раза в месяц. Освещает все рыночные сегменты – офисную, ' +
      'складскую, торговую, гостиничную недвижимость и т.д. ',
  },
  {
    title: 'Гид «Управление недвижимостью» ',
    subtitle:
      ' Полноценный рабочий инструмент для всех, кто имеет отношение ' +
      'к рынку недвижимости и хочет при помощи грамотного управления сохранить ' +
      'стоимость объекта недвижимости в долгосрочной перспективе. Свои материалы ' +
      'представляют лучшие эксперты России. Выходит 2 раза в год ',
  },
  {
    title: 'Склады и Логистика ',
    subtitle:
      'Ежеквартальный журнал о складском рынке. ' +
      'Площадка для коммуникаций всех его участников – девелоперов ' +
      'складской недвижимости, брокеров и арендаторов. Интервью с ' +
      'первыми лицами компаний, репортажи с лучших объектов. ',
  },
  {
    title: 'CID',
    subtitle:
      'Ежегодное издание, посвященное рынку инвестиций: ' +
      'аналитика, прогнозы, кейсы от экспертов, обзор всех сегментов. ',
  },
  {
    title: 'CRE 100',
    subtitle:
      'Ежегодный редакционный рейтинг самых ' +
      'влиятельных персон рынка коммерческой недвижимости России. ',
  },
  {
    title: 'CRE 101',
    subtitle:
      'Ежегодный редакционный рейтинг самых ' +
      'влиятельных персон рынка коммерческой недвижимости России. ',
  },
  {
    title: 'CRE 102',
    subtitle:
      'Ежегодный редакционный рейтинг самых ' +
      'влиятельных персон рынка коммерческой недвижимости России. ',
  },
  {
    title: 'CRE PRO',
    subtitle:
      'Редакционный рейтинг выдающихся профессионалов ' +
      'рынка коммерческой недвижимости. Герои проекта – те, кто, ' +
      'не являясь владельцами или прямыми руководителями компаний, ' +
      'пользуются заслуженным авторитетом среди коллег и формируют рынок ' +
      'коммерческой недвижимости. ',
  },
];

const news__info__first = NEWS_INFO[0];
const news__info__middle = ref(Array.from(NEWS_INFO));
news__info__middle.value.shift();
news__info__middle.value.pop();
const news__info__last = NEWS_INFO.at(-1);
</script>

<template>
  <div :class="$style.advertising__body">
    <div :class="$style.advertising__body_title">Наши издания</div>
    <div :class="$style.advertising__body__grid">
      <div :class="$style.advertising__body__info">
        <img
          :src="AdvertisingImg"
          :class="$style.advertising__body_image"
          alt=""
        />
        <div :class="$style.advertising__body_name">
          {{ news__info__first?.title }}
        </div>
        <div :class="$style.advertising__body_description">
          {{ news__info__first?.subtitle }}
        </div>
      </div>
      <div :class="$style.advertising__body__row">
        <div
          v-for="(grid, index) in news__info__middle"
          :key="`grid-${index}`"
          :class="$style.advertising__body__block"
        >
          <div :class="$style.advertising__body_heading">
            {{ grid.title }}
          </div>
          <div :class="$style.advertising__body_description">
            {{ grid.subtitle }}
          </div>
        </div>
      </div>
      <div :class="$style.advertising__body__texts">
        <div :class="$style.advertising__body_heading">
          {{ news__info__last?.title }}
        </div>
        <div :class="$style.advertising__body_description">
          {{ news__info__last?.subtitle }}
        </div>
      </div>
    </div>
  </div>
</template>

<style module lang="scss">
.advertising__body {
  &_title {
    @include text_h5;
    padding: var(--space-2-5x);
    color: var(--color-black-2);
    border-bottom: 1px solid var(--color-gray-line);
  }

  &_name {
    @include text_h4;
    color: var(--color-black-1);
  }

  &_heading {
    font: 700 normal 18px/120% var(--font-golos);
    margin-bottom: var(--space-1-5x);
    color: var(--color-black-1);
  }

  &_description {
    @include text_body2;
    color: var(--color-black-1);
  }

  &__info {
    padding: var(--space-2-5x);
    display: flex;
    flex-direction: column;
    gap: var(--space-2-5x);
    border-bottom: 1px solid var(--color-gray-line);
    grid-column: 1 / 2;
    grid-row: 1 / 2;
  }

  &__block {
    padding: var(--space-2-5x);
    border-left: 1px solid var(--color-gray-line);
    border-bottom: 1px solid var(--color-gray-line);
  }

  &__texts {
    padding: var(--space-2-5x) 19px var(--space-2-5x) var(--space-2-5x);
    grid-column: 1 / 2;
    grid-row: 2 / 3;
    border-bottom: 1px solid var(--color-gray-line);
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto auto;
  }

  &__row {
    grid-column: 2 / 3;
    grid-row: 1 / 3;
  }
}
</style>
